module.exports = __webpack_public_path__ + "media/images/blue-dot-icon-a7c2890fd213f0f717edf0d576319338.jpeg";